import React, { useEffect, useState  } from 'react';
import { Box, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import { MainLineChart } from './charts'
import BookingTable from './bookingTable'
import { getAllBookings } from '../../services/booking'
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);

const transformData = (startDate, endDate, data) => {
    const daysInMonth = endDate.date();

    const aggregatedHours = Array.from({ length: daysInMonth }, (_, i) => ({
        date: startDate.add(i, "day").format("DD-MM-YYYY"),
        hoursOccupied: 0,
    }));

    data.forEach(({ from, to, tenant, amount, totalHours, advance, discount }) => {
        let start = dayjs(from);
        let end = dayjs(to);
    
        start = start.isBefore(startDate) ? startDate : start;
        end = end.isAfter(endDate) ? endDate : end;

        while (start.isBefore(end) || start.isSame(end, "minute")) {
            const currentDayIndex = start.date() - 1;
            const nextDay = start.endOf("day");

        
            const occupiedTime = end.isBefore(nextDay)
            ? end.diff(start, "hours", true)
            : nextDay.diff(start, "hours", true);

            if (Array.isArray(aggregatedHours[currentDayIndex].bookings)) {
                aggregatedHours[currentDayIndex].bookings.push({from, to, tenant, amount, totalHours, advance, discount})  
            } else {
                aggregatedHours[currentDayIndex].bookings=[{from, to, tenant, amount, totalHours, advance, discount}];
            }

            aggregatedHours[currentDayIndex].hoursOccupied += Math.ceil(occupiedTime);

            if (aggregatedHours[currentDayIndex].aggregatedAmount) {
                console.log(aggregatedHours[currentDayIndex].aggregatedAmount, amount)
                aggregatedHours[currentDayIndex].aggregatedAmount = aggregatedHours[currentDayIndex].aggregatedAmount + amount
            } else {
                console.log(amount)
                aggregatedHours[currentDayIndex].aggregatedAmount =  amount
            }
            start = nextDay.add(1, "minute");
        }
    });
    
    return aggregatedHours;
};    


const MonthSelector = ({selectedMonth, setSelectedMonth}) =>{
    const months = [0, 1, 2].map((i) => ({value:  dayjs().subtract(i, "month").format('M-YYYY'),  label: dayjs().subtract(i, "month").format("MMMM YYYY")}));

    const handleChange = (e) => {
        setSelectedMonth(e.target.value)
    }

    useEffect(()=>{
        setSelectedMonth(months[0].value)
    }, [])

    if (selectedMonth !== undefined) {
        return (
            <Box sx={{ pl: 2, pr: 2, pt:1 }}>
                <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Month</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Age"
                    value={selectedMonth}
                    onChange={handleChange}
                >
                    {months.map(month => (<MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>))}                
                </Select>
                </FormControl>
            </Box>
        )
    }
    return null;
}

const Reports = () => {
    const [bookings, setBookings] = useState([])
    const [chartData, setChartData] = useState([])
    const [selectedMonth, setSelectedMonth] = useState()
    
    
    let startDate, endDate;


    const getAllBookingsData = async(_selectedMonth) =>{
        try {
            //const start = dayjs(selectedMonth, 'M-YYYY').startOf('month').format('DD-MM-YYYY')
            //const end = dayjs(selectedMonth, 'M-YYYY').endOf('month').format('DD-MM-YYYY')
            const data = await getAllBookings(startDate.format('DD-MM-YYYY'), endDate.format('DD-MM-YYYY'))
            setBookings(transformData(startDate, endDate, data))
            //setBookings(data)
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() =>{
        if (selectedMonth) {
            startDate = dayjs(selectedMonth, 'M-YYYY').startOf('month')
            endDate = dayjs(selectedMonth, 'M-YYYY').endOf('month')
            getAllBookingsData(selectedMonth)
        }
    }, [selectedMonth])    
    return (
        <Box sx={{maxHeight: '90vh'}}>
            <Typography sx={{width: '100%', textAlign: 'center', mt: 2, fontWeight: 'bold', fontSize: '1.4rem'}}>Report</Typography>
            <MonthSelector selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth}/>
            <MainLineChart bookings={bookings}/>
            <BookingTable bookings={bookings}/>
        </Box>
    )
}

export default Reports